import React from 'react';
import Link from 'redux-first-router-link';
import PropTypes from 'prop-types';
import BrandLogo from './BrandLogo';
import Socials from './Socials';
import SearchForm from '../Search/SearchForm';

export const Nav = ({
  onCloseClick,
  isMobile,
}) => (
  <div className="nav" onTouchStart={(e) => {
    if (isMobile) {
      e.stopPropagation();
    }
  }}>
    <div className="nav-content">
      <div className="nav-close icon-close-icon-NEW" onClick={onCloseClick} />
      <BrandLogo onClick={onCloseClick} />
      <p className="nav-tagline">Own your future, start this minute.</p>
      {isMobile
        && <SearchForm cssClass="nav-item" canCollapse={false} parent="nav" />
      }
      <div className="nav-links">
        <Link
          onClick={onCloseClick}
          className="nav-link grind"
          to={{ type: 'LANDER', payload: { category: 'grind' } }}>
          Grind
        </Link>
        <Link
          onClick={onCloseClick}
          className="nav-link culture"
          to={{ type: 'LANDER', payload: { category: 'culture' } }}>
          Culture
        </Link>
        <Link
          onClick={onCloseClick}
          className="nav-link strength"
          to={{ type: 'LANDER', payload: { category: 'strength' } }}>
          Strength
        </Link>
        <Link
          onClick={onCloseClick}
          className="nav-link style"
          to={{ type: 'LANDER', payload: { category: 'style' } }}>
          Style
        </Link>
      </div>
      <hr/>
      <div className="subnav-links">
        <Link
          onClick={onCloseClick}
          className="subnav-link featured-content"
          to={{ type: 'LANDER', payload: { category: 'featured-content' } }}>
          Featured Content
        </Link>
        <Link
          onClick={onCloseClick}
          className="subnav-link entrepreneurial-athletes"
          to={{ type: 'SUBLANDER', payload: { category: 'grind', subcategory: 'entrepreneurial-athletes' } }}>
          30 Entrepreneurial Athletes
        </Link>
        <Link
          onClick={onCloseClick}
          className="subnav-link roster"
          to={{ type: 'LANDER', payload: { category: 'roster' } }}>
          The Roster
        </Link>
        {/* remove once The Roster is live
        <h3 className="nav-roster-hed">The Roster</h3>
         remove once The Roster is live
        <h4 className="nav-roster-subhed">coming soon</h4>*/}
      </div>
      <Socials parent="Nav" />
      <div className="subnav-links">
        <Link
          onClick={onCloseClick}
          className="subnav-link about"
          to={{ type: 'ABOUT' }}>
          About Us
        </Link>
        <Link
          onClick={onCloseClick}
          className="subnav-link contributor"
          to={{ type: 'CONTRIBUTE' }}>
          Become a Contributor
        </Link>
      </div>
    </div>
  </div>

);

Nav.propTypes = {
  onCloseClick: PropTypes.func,
  isMobile: PropTypes.bool,
};

export default Nav;
